module.exports = __webpack_public_path__ + "img/logo-scg.70736a03.png";